import './weekNumberCalender.scss';
import React, { useLayoutEffect, useState, useRef, useEffect } from 'react';

interface ICell {
    startTime2?: number;
    endTime2?: number;
    color2?: string;
    userList2?: string[];
    startTime3?: number;
    endTime3?: number;
    color3?: string;
    userList3?: string[];
    color: string;
    startTime: number;
    endTime: number;
    userList: string[];
    id: number;
    date?: string;
}

interface IColumn {
    cells: ICell[];
}
interface IRow {
    columns: IColumn[];
}
interface IDataTable {
    rows: IRow[];
}

interface IWeekNumberCalender {
    onTabClick(data: ICell): any;
}

const WeekNumberCalender = ({ onTabClick }: IWeekNumberCalender) => {
    const [width, setWidth] = useState(0);
    const elementRef = useRef(null);

    useEffect(() => {
        if (elementRef.current !== null) {
            const { offsetWidth } = elementRef.current;
            setWidth(offsetWidth);
        }
    }, [window.innerWidth]);

    const hourCount = 24;
    const hourCountHeader = '날짜';
    const weekStartDate = 23;
    const hourCountLabels = new Array<number>(hourCount);
    const customElements = [
        {
            id: 1,
            date: 23,
            startTime: 9,
            endTime: 13,
            color: '#49ae9e',
            userList: ['https://i.pravatar.cc/150?img=34'],
        },
        {
            id: 2,
            date: 24,
            startTime: 9,
            endTime: 13,
            color: '#49ae9e',
            userList: ['https://i.pravatar.cc/150?img=43'],
            startTime2: 13,
            endTime2: 18,
            color2: '#DE9F54',
            userList2: [
                'https://i.pravatar.cc/150?img=43',
                'https://i.pravatar.cc/150?img=2',
                'https://i.pravatar.cc/150?img=31',
                'https://i.pravatar.cc/150?img=4',
            ],
            startTime3: 12,
            endTime3: 15,
            color3: '#6651A4',
            userList3: ['https://i.pravatar.cc/150?img=43'],
        },
        {
            id: 3,
            date: 25,
            startTime: 9,
            endTime: 13,
            color: '#49ae9e',
            userList: ['https://i.pravatar.cc/150?img=3' ],
        },
        {
            id: 3,
            date: 26,
            startTime: 9,
            endTime: 13,
            color: '#49ae9e',
            userList: ['https://i.pravatar.cc/150?img=3' ],
        },
        {
            id: 3,
            date: 27,
            startTime: 9,
            endTime: 13,
            color: '#49ae9e',
            userList: ['https://i.pravatar.cc/150?img=3' ],
        },
        {
            id: 3,
            date: 28,
            startTime: 9,
            endTime: 13,
            color: '#49ae9e',
            userList: ['https://i.pravatar.cc/150?img=3' ],
        },
        {
            id: 4,
            date: 29,
            startTime: 9,
            endTime: 13,
            color: '#49ae9e',
            userList: ['https://i.pravatar.cc/150?img=1'],
        },
    ];
    const columnHeaders = [
        '10.23 (일)',
        '10.24 (월)',
        '10.25 (화)',
        '10.26 (수)',
        '10.27 (목)',
        '10.28 (금)',
        '10.29 (토)',
    ];

    for (let index = 0; index < hourCount; index++) {
        hourCountLabels.push(index);
    }

    //create 2d array
    const tableDaysArray: ICell[][] = new Array(7).fill(false).map(() =>
        new Array(24).fill({
            color: null,
            startTime: 0,
            endTime: 5,
            userList: [],
        }),
    );

    //feed 2d array
    for (const key in customElements) {
        const element = customElements[key];
        const { date, ...elementWithoutDate } = element;
        tableDaysArray[element.date - weekStartDate][element.startTime] = elementWithoutDate;
    }

    return (
        <div className="weekNumberCalenderComponent">
            <table className="table">
                <tr className="topRow">
                    <th className="weekNumberHeaderTitle">{hourCountHeader}</th>
                    {hourCountLabels.map((label) => {
                        return <th className="weekNumberHeader">{label}</th>;
                    })}
                </tr>
                {tableDaysArray.map((row, index) => {
                    return (
                        <tr>
                            <td
                                className={`columnHeaders ${
                                    index == 0 || index == tableDaysArray.length - 1 ? 'columnHeadersSpecials' : ''
                                }`}
                            >
                                {columnHeaders[index]}
                            </td>
                            {row.map((strip) => {
                                return (
                                    <td className="normalCell" ref={elementRef}>
                                        {strip.color != null ? (
                                            <div
                                                key={strip.id}
                                                className="dataContainer"
                                                style={{
                                                    width: `${width * (Number(strip.endTime) - strip.startTime) + 3}px`,
                                                    background: strip.color,
                                                    position: 'relative',
                                                }}
                                                onClick={() => {
                                                    onTabClick({ ...strip, date: columnHeaders[index] });
                                                }}
                                            >
                                                {`${strip.startTime}:00  ~  ${strip.endTime}:00`}

                                                <div
                                                    className="userList"
                                                    style={{
                                                        width: `${10 * strip.userList.length}px`,
                                                        right: `${15 * strip.userList.length}px`,
                                                    }}
                                                >
                                                    {strip.userList.map((user, index) => (
                                                        <img
                                                            src={user}
                                                            alt=""
                                                            className="avatarImage"
                                                            style={{ left: `${10 * index}px` }}
                                                        />
                                                    ))}
                                                </div>
                                            </div>
                                        ) : (
                                            <></>
                                        )}

                                        {strip.startTime2 ? (
                                            <>
                                                <div
                                                    key={strip.id}
                                                    className="dataContainer"
                                                    style={{
                                                        width: `${
                                                            width * (Number(strip.endTime2) - strip.startTime2)
                                                        }px`,
                                                        background: strip.color2,
                                                        position: 'relative',
                                                        left: `${2.9 * (Number(strip.endTime2) - strip.startTime2)}rem`,
                                                        // left: '3.8rem'
                                                    }}
                                                    onClick={() => {
                                                        onTabClick({ ...strip, date: columnHeaders[index] });
                                                    }}
                                                >
                                                    {`${strip.startTime2}:00  ~  ${strip.endTime2}:00`}

                                                    <div
                                                        className="userList" 
                                                    >
                                                        {strip.userList2?.map((user, index) => (
                                                            <img
                                                                src={user}
                                                                alt=""
                                                                className="avatarImage"
                                                                style={{ left: `${10 * index}px` }}
                                                            />
                                                        ))}
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            <></>
                                        )}

                                        {strip.startTime3 ? (
                                            <>
                                                <div
                                                    key={strip.id}
                                                    className="dataContainer"
                                                    style={{
                                                        width: `${
                                                            width * (Number(strip.endTime3) - strip.startTime3)
                                                        }px`,
                                                        background: strip.color3,
                                                        position: 'relative',
                                                        left: `${67 * (Number(strip.endTime3) - strip.startTime3)}%`,
                                                    }}
                                                    onClick={() => {
                                                        onTabClick({ ...strip, date: columnHeaders[index] });
                                                    }}
                                                >
                                                    {`${strip.startTime3}:00  ~  ${strip.endTime3}:00`}

                                                    <div
                                                        className="userList"
                                                        style={{
                                                            width: `${10 * [strip.userList3].length}px`,
                                                            right: `${15 * [strip.userList3].length}px`,
                                                        }}
                                                    >
                                                        {strip.userList3?.map((user, index) => (
                                                            <img
                                                                src={user}
                                                                alt=""
                                                                className="avatarImage"
                                                                style={{ left: `${10 * index}px` }}
                                                            />
                                                        ))}
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                    </td>
                                );
                            })}
                        </tr>
                    );
                })}
            </table>
        </div>
    );
};

export default WeekNumberCalender;
